// What the scenario screen's hover cards say.
//
// Prose, and no rendering: the screen prints a name and a current value, and
// every sentence explaining one is a card body (`ScenarioScreen.css`'s rule 2,
// which is now `HoverCard`'s). Its own module so the screen is state and
// layout — the same split `watchCpu.ts` makes against its page.

import { DIRECTIONS, forwardFacing } from "src/shared/board";

/**
 * Which way an army marches, in words.
 *
 * Off `forwardFacing`, which is what the reducer actually gives the army's
 * pawns — so it is true on every board rather than only on the one laid out on
 * four edges. Where it *sits* would be more useful and is not derivable: the
 * skirmish's two camps both land in the north facing different ways.
 */
export function marchHint(side: number): string {
  return `marches ${["north", "east", "south", "west"][DIRECTIONS.indexOf(forwardFacing(side))]}.`;
}
